import React from 'react';

/**
 * Composant d'en-tête de tableau triable
 * @param {string} label - Texte à afficher dans l'en-tête
 * @param {string} field - Nom du champ correspondant dans la DB
 * @param {string} currentSort - Champ actuellement trié (sortBy)
 * @param {string} currentOrder - Ordre actuel (ASC ou DESC)
 * @param {function} onSort - Callback appelé lors du clic (field, order)
 * @param {string} className - Classes CSS additionnelles
 */
const SortableHeader = ({ label, field, currentSort, currentOrder, onSort, className = "", as = "th", noPadding = false }) => {
    const isActive = currentSort === field;
    const Tag = as;

    const handleSort = () => {
        let newOrder = 'ASC';
        if (isActive) {
            newOrder = currentOrder === 'ASC' ? 'DESC' : 'ASC';
        }
        onSort(field, newOrder);
    };

    const basePadding = noPadding ? "" : "px-6 py-4";

    return (
        <Tag
            onClick={handleSort}
            className={`${basePadding} ${as === 'th' ? 'border-b border-slate-200 dark:border-slate-800' : ''} text-xs font-bold text-slate-400 uppercase tracking-widest cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors group ${className}`}
        >
            <div className="flex items-center gap-2">
                {label}
                <div className="flex flex-col">
                    <span className={`material-symbols-outlined text-[14px] leading-[8px] ${isActive && currentOrder === 'ASC' ? 'text-primary' : 'text-slate-300 dark:text-slate-600 group-hover:text-slate-400'}`}>
                        arrow_drop_up
                    </span>
                    <span className={`material-symbols-outlined text-[14px] leading-[8px] ${isActive && currentOrder === 'DESC' ? 'text-primary' : 'text-slate-300 dark:text-slate-600 group-hover:text-slate-400'}`}>
                        arrow_drop_down
                    </span>
                </div>
            </div>
        </Tag>
    );
};

export default SortableHeader;
